// @flow

import { onlyNumbers } from '@tectonics/prs/normalize';

export function normalizeCustomerDocument(documentValue: ?string): string {
  return documentValue ? onlyNumbers(documentValue) : '';
}
